<template>
  <Navbar />
  <Slider />
  <Partners />
  <Tronics />
  <Footer />
</template>

<script>
import Navbar from "@/components/store/Navbar";
import Slider from "@/components/store/Slider";
import Partners from "@/components/store/Partners";
import Tronics from "@/components/store/Tronics";
import Footer from "@/components/store/Footer";

export default {
  components: {Navbar, Slider, Partners, Tronics, Footer}
}
</script>
